import { useEffect } from 'react';
import { FormattedMessage, trans } from '@lingoda/i18n';
import { UserDisplayedWidgetClassEnum } from '@lingoda/monolith-graphql';
import { Alert, Link, Stack, Typography, colorsPalette } from '@lingoda/ui';
import { SupportUrlType, getSupportUrl } from '@lingoda/urls';
import { useMarkWidgetAsDisplayed } from '../hooks';

interface Props {
    markAsDisplayedOnMount?: boolean;
}

export const ClassesInClassroomAlert = ({
    children,
    markAsDisplayedOnMount,
}: React.PropsWithChildren<Props>) => {
    const { markAsDisplayed } = useMarkWidgetAsDisplayed();

    useEffect(() => {
        if (markAsDisplayedOnMount) {
            markAsDisplayed(UserDisplayedWidgetClassEnum.StudentFutureClassInClassroomBanner);
        }
    }, [markAsDisplayed, markAsDisplayedOnMount]);

    return (
        <Alert variant="outlined" severity="promotion" size="compact" icon={false} fullWidth>
            <Stack spacing={1} alignItems="flex-start">
                <Typography variant="subtitle1" htmlColor="text.primary">
                    {trans('join-classes-in-browser', {}, 'student-common')}
                </Typography>
                <Typography variant="body2" htmlColor="text.primary">
                    <FormattedMessage
                        message={trans('classes-in-lingoda-classroom-alert', {}, 'student-common')}
                        values={{
                            a: (chunks) => (
                                <Link
                                    href={getSupportUrl(SupportUrlType.ClassroomStudentFAQ)}
                                    target="_blank"
                                    rel="noreferrer"
                                    sx={{ color: colorsPalette.purpleSolid[100] }}
                                >
                                    {chunks}
                                </Link>
                            ),
                        }}
                    />
                </Typography>
                {children}
            </Stack>
        </Alert>
    );
};
